import { render, staticRenderFns } from "./datasource.vue?vue&type=template&id=21091a5e&scoped=true&"
import script from "./datasource.vue?vue&type=script&lang=ts&"
export * from "./datasource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21091a5e",
  null
  
)

export default component.exports